import NavigationFooter from './NavigationFooter';

export { type NavigationFooterProps } from './NavigationFooter';
export default NavigationFooter;
